import { useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";
import { useSetMapByGranularity } from "./useSetMapByGranularity";

export const useChatConversations = (data: any) => {
  const { setMap } = useSetMapByGranularity([
    KPI_CODES.CHAT_TODAY,
    KPI_CODES.CHAT_THIS_MONTH,
    KPI_CODES.CHAT_THIS_YEAR,
  ]);

  const conversations = useMemo(
    () => (data ? setMap(data) : {}),
    [data, setMap],
  );

  return { conversations };
};
